/**
 * Stok Hareketleri Mock Verisi
 * 
 * Tüm stok giriş, çıkış, aktarım ve düzeltme kayıtları.
 */

export const stokHareketleri = [
    // Demir hareketleri
    {
        id: 'sh-m-001',
        malzemeTipi: 'demir',
        altTip: 'Ø8',
        hareketTipi: 'giris',
        miktar: 30,
        oncekiStok: 0,
        sonrakiStok: 30,
        kaynak: 'İsdemir',
        hedef: 'Ana Depo',
        insaatId: 'c-001',
        tarih: '2026-01-10',
        aciklama: 'Yeni satın alma — Etriye demiri',
    },
    {
        id: 'sh-m-002',
        malzemeTipi: 'demir',
        altTip: 'Ø8',
        hareketTipi: 'cikis',
        miktar: 20,
        oncekiStok: 30,
        sonrakiStok: 10,
        kaynak: 'Ana Depo',
        hedef: 'A Blok İnşaat',
        insaatId: 'c-001',
        tarih: '2026-01-15',
        aciklama: 'İnşaatta kullanım',
    },
    {
        id: 'sh-m-003',
        malzemeTipi: 'demir',
        altTip: 'Ø12',
        hareketTipi: 'giris',
        miktar: 25,
        oncekiStok: 0,
        sonrakiStok: 25,
        kaynak: 'Kardemir A.Ş.',
        hedef: 'Ana Depo',
        insaatId: 'c-001',
        tarih: '2026-01-05',
        aciklama: 'Temel demiri satın alma',
    },
    {
        id: 'sh-m-004',
        malzemeTipi: 'demir',
        altTip: 'Ø12',
        hareketTipi: 'cikis',
        miktar: 20,
        oncekiStok: 25,
        sonrakiStok: 5,
        kaynak: 'Ana Depo',
        hedef: 'A Blok İnşaat',
        insaatId: 'c-001',
        tarih: '2026-01-12',
        aciklama: 'Temel demiri kullanımı',
    },
    {
        id: 'sh-m-005',
        malzemeTipi: 'demir',
        altTip: 'Ø14',
        hareketTipi: 'aktarim',
        miktar: 3,
        oncekiStok: 8,
        sonrakiStok: 5,
        kaynak: 'B Blok',
        hedef: 'C Blok İnşaat',
        insaatId: 'c-003',
        tarih: '2026-01-25',
        aciklama: 'İnşaatlar arası aktarım',
    },
    {
        id: 'sh-m-006',
        malzemeTipi: 'demir',
        altTip: 'Ø16',
        hareketTipi: 'duzeltme',
        miktar: 1,
        oncekiStok: 4,
        sonrakiStok: 3,
        kaynak: 'Manuel Düzeltme',
        hedef: 'Ana Depo',
        insaatId: null,
        tarih: '2026-01-20',
        aciklama: 'Sayım farkı düzeltmesi',
    },

    // Parke hareketleri
    {
        id: 'sh-m-010',
        malzemeTipi: 'parke',
        altTip: 'Laminat',
        hareketTipi: 'giris',
        miktar: 250,
        oncekiStok: 0,
        sonrakiStok: 250,
        kaynak: 'Kronospan',
        hedef: 'Ana Depo',
        insaatId: 'c-001',
        tarih: '2026-01-10',
        aciklama: 'Laminat parke satın alma',
    },
    {
        id: 'sh-m-011',
        malzemeTipi: 'parke',
        altTip: 'Laminat',
        hareketTipi: 'cikis',
        miktar: 200,
        oncekiStok: 250,
        sonrakiStok: 50,
        kaynak: 'Ana Depo',
        hedef: 'A Blok İnşaat',
        insaatId: 'c-001',
        tarih: '2026-01-18',
        aciklama: 'Daire döşeme kullanımı',
    },
    {
        id: 'sh-m-012',
        malzemeTipi: 'parke',
        altTip: 'Masif',
        hareketTipi: 'giris',
        miktar: 80,
        oncekiStok: 0,
        sonrakiStok: 80,
        kaynak: 'Doğtaş Parke',
        hedef: 'Ana Depo',
        insaatId: 'c-002',
        tarih: '2026-01-12',
        aciklama: 'Masif parke satın alma',
    },
    {
        id: 'sh-m-013',
        malzemeTipi: 'parke',
        altTip: 'Masif',
        hareketTipi: 'cikis',
        miktar: 55,
        oncekiStok: 80,
        sonrakiStok: 25,
        kaynak: 'Ana Depo',
        hedef: 'B Blok İnşaat',
        insaatId: 'c-002',
        tarih: '2026-01-22',
        aciklama: 'Salon döşemesi',
    },
    {
        id: 'sh-m-014',
        malzemeTipi: 'parke',
        altTip: 'Laminat',
        hareketTipi: 'aktarim',
        miktar: 20,
        oncekiStok: 50,
        sonrakiStok: 30,
        kaynak: 'A Blok Stok',
        hedef: 'C Blok İnşaat',
        insaatId: 'c-003',
        tarih: '2026-01-28',
        aciklama: 'Stoktan yeni inşaata aktarım',
    },

    // Tuğla hareketleri
    { id: 'sh-m-020', malzemeTipi: 'tugla', altTip: '13.5 Yatay Delikli', hareketTipi: 'giris', miktar: 20000, oncekiStok: 0, sonrakiStok: 20000, kaynak: 'Ataş Tuğla', hedef: 'Ana Depo', insaatId: 'c-001', tarih: '2026-01-10', aciklama: 'Tuğla satın alma' },
    { id: 'sh-m-021', malzemeTipi: 'tugla', altTip: '13.5 Yatay Delikli', hareketTipi: 'cikis', miktar: 5000, oncekiStok: 20000, sonrakiStok: 15000, kaynak: 'Ana Depo', hedef: 'A Blok', insaatId: 'c-001', tarih: '2026-01-18', aciklama: 'Duvar örme kullanımı' },
    { id: 'sh-m-022', malzemeTipi: 'tugla', altTip: 'Gazbeton Blok', hareketTipi: 'giris', miktar: 4000, oncekiStok: 0, sonrakiStok: 4000, kaynak: 'Ytong', hedef: 'B Blok', insaatId: 'c-002', tarih: '2026-01-15', aciklama: 'Gazbeton alımı' },

    // İzolasyon hareketleri
    { id: 'sh-m-030', malzemeTipi: 'izolasyon', altTip: 'Isı Yalıtım', hareketTipi: 'giris', miktar: 1500, oncekiStok: 0, sonrakiStok: 1500, kaynak: 'İzocam', hedef: 'Ana Depo', insaatId: 'c-001', tarih: '2026-01-08', aciklama: 'XPS ısı yalıtım satın alma' },
    { id: 'sh-m-031', malzemeTipi: 'izolasyon', altTip: 'Isı Yalıtım', hareketTipi: 'cikis', miktar: 300, oncekiStok: 1500, sonrakiStok: 1200, kaynak: 'Ana Depo', hedef: 'A Blok', insaatId: 'c-001', tarih: '2026-01-15', aciklama: 'Dış cephe yalıtımı' },
    { id: 'sh-m-032', malzemeTipi: 'izolasyon', altTip: 'Su Yalıtım', hareketTipi: 'giris', miktar: 800, oncekiStok: 0, sonrakiStok: 800, kaynak: 'BTM', hedef: 'Ana Depo', insaatId: 'c-001', tarih: '2026-01-12', aciklama: 'Membran satın alma' },

    // Elektrik hareketleri
    { id: 'sh-m-040', malzemeTipi: 'elektrik', altTip: 'Kablo', hareketTipi: 'giris', miktar: 8000, oncekiStok: 0, sonrakiStok: 8000, kaynak: 'Prysmian', hedef: 'Elektrik Deposu', insaatId: 'c-001', tarih: '2026-01-05', aciklama: 'NYM kablo satın alma' },
    { id: 'sh-m-041', malzemeTipi: 'elektrik', altTip: 'Kablo', hareketTipi: 'cikis', miktar: 3000, oncekiStok: 8000, sonrakiStok: 5000, kaynak: 'Elektrik Deposu', hedef: 'A Blok', insaatId: 'c-001', tarih: '2026-01-12', aciklama: 'Tesisat çekimi' },
    { id: 'sh-m-042', malzemeTipi: 'elektrik', altTip: 'Priz/Anahtar', hareketTipi: 'giris', miktar: 400, oncekiStok: 0, sonrakiStok: 400, kaynak: 'Schneider', hedef: 'Elektrik Deposu', insaatId: 'c-001', tarih: '2026-01-10', aciklama: 'Priz ve anahtar alımı' },

    // Su Tesisatı hareketleri
    { id: 'sh-m-050', malzemeTipi: 'suTesisati', altTip: 'PPR Boru', hareketTipi: 'giris', miktar: 5000, oncekiStok: 0, sonrakiStok: 5000, kaynak: 'Pilsa', hedef: 'Tesisat Deposu', insaatId: 'c-001', tarih: '2026-01-06', aciklama: 'PPR boru satın alma' },
    { id: 'sh-m-051', malzemeTipi: 'suTesisati', altTip: 'PPR Boru', hareketTipi: 'cikis', miktar: 2000, oncekiStok: 5000, sonrakiStok: 3000, kaynak: 'Tesisat Deposu', hedef: 'A Blok', insaatId: 'c-001', tarih: '2026-01-14', aciklama: 'Döşeme tesisat çekimi' },
    { id: 'sh-m-052', malzemeTipi: 'suTesisati', altTip: 'Fitting', hareketTipi: 'giris', miktar: 1000, oncekiStok: 0, sonrakiStok: 1000, kaynak: 'Wavin', hedef: 'Tesisat Deposu', insaatId: 'c-001', tarih: '2026-01-08', aciklama: 'Fitting ek parça alımı' },

    // Doğalgaz hareketleri
    { id: 'sh-m-060', malzemeTipi: 'dogalgaz', altTip: 'Çelik Boru', hareketTipi: 'giris', miktar: 2000, oncekiStok: 0, sonrakiStok: 2000, kaynak: 'Borusan', hedef: 'Tesisat Deposu', insaatId: 'c-001', tarih: '2026-01-10', aciklama: 'Çelik boru satın alma' },
    { id: 'sh-m-061', malzemeTipi: 'dogalgaz', altTip: 'Çelik Boru', hareketTipi: 'cikis', miktar: 500, oncekiStok: 2000, sonrakiStok: 1500, kaynak: 'Tesisat Deposu', hedef: 'A Blok', insaatId: 'c-001', tarih: '2026-01-18', aciklama: 'Gaz hattı döşeme' },

    // Alçı/Sıva hareketleri
    { id: 'sh-m-070', malzemeTipi: 'alciSiva', altTip: 'Alçı', hareketTipi: 'giris', miktar: 500, oncekiStok: 0, sonrakiStok: 500, kaynak: 'Knauf', hedef: 'Ana Depo', insaatId: 'c-001', tarih: '2026-01-08', aciklama: 'Alçı satın alma' },
    { id: 'sh-m-071', malzemeTipi: 'alciSiva', altTip: 'Alçı', hareketTipi: 'cikis', miktar: 200, oncekiStok: 500, sonrakiStok: 300, kaynak: 'Ana Depo', hedef: 'A Blok', insaatId: 'c-001', tarih: '2026-01-16', aciklama: 'Duvar alçı sıva' },
    { id: 'sh-m-072', malzemeTipi: 'alciSiva', altTip: 'Sıva', hareketTipi: 'giris', miktar: 500, oncekiStok: 0, sonrakiStok: 500, kaynak: 'Weber', hedef: 'Ana Depo', insaatId: 'c-001', tarih: '2026-01-12', aciklama: 'Sıva malzemesi alımı' },

    // Seramik hareketleri
    { id: 'sh-m-080', malzemeTipi: 'seramik', altTip: 'Yer Seramiği', hareketTipi: 'giris', miktar: 1200, oncekiStok: 0, sonrakiStok: 1200, kaynak: 'Kaleseramik', hedef: 'Ana Depo', insaatId: 'c-001', tarih: '2026-01-10', aciklama: 'Yer seramiği satın alma' },
    { id: 'sh-m-081', malzemeTipi: 'seramik', altTip: 'Yer Seramiği', hareketTipi: 'cikis', miktar: 400, oncekiStok: 1200, sonrakiStok: 800, kaynak: 'Ana Depo', hedef: 'A Blok', insaatId: 'c-001', tarih: '2026-01-17', aciklama: 'Banyo ve mutfak döşemesi' },
    { id: 'sh-m-082', malzemeTipi: 'seramik', altTip: 'Duvar Seramiği', hareketTipi: 'giris', miktar: 600, oncekiStok: 0, sonrakiStok: 600, kaynak: 'Ege Seramik', hedef: 'Ana Depo', insaatId: 'c-001', tarih: '2026-01-12', aciklama: 'Duvar seramik alımı' },

    // Boya hareketleri
    { id: 'sh-m-090', malzemeTipi: 'boya', altTip: 'İç Cephe', hareketTipi: 'giris', miktar: 1200, oncekiStok: 0, sonrakiStok: 1200, kaynak: 'Marshall', hedef: 'Ana Depo', insaatId: 'c-001', tarih: '2026-01-08', aciklama: 'İç cephe boya alımı' },
    { id: 'sh-m-091', malzemeTipi: 'boya', altTip: 'İç Cephe', hareketTipi: 'cikis', miktar: 400, oncekiStok: 1200, sonrakiStok: 800, kaynak: 'Ana Depo', hedef: 'A Blok', insaatId: 'c-001', tarih: '2026-01-15', aciklama: 'Salon boyama' },
    { id: 'sh-m-092', malzemeTipi: 'boya', altTip: 'Dış Cephe', hareketTipi: 'giris', miktar: 500, oncekiStok: 0, sonrakiStok: 500, kaynak: 'Filli Boya', hedef: 'Ana Depo', insaatId: 'c-001', tarih: '2026-01-12', aciklama: 'Dış cephe boya alımı' },
];

/**
 * Malzeme tipine göre hareketler
 */
export const getHareketler = (malzemeTipi) => {
    return stokHareketleri
        .filter(h => h.malzemeTipi === malzemeTipi)
        .sort((a, b) => new Date(b.tarih) - new Date(a.tarih));
};

/**
 * Hareket tipi label ve renkleri
 */
export const hareketTipleri = {
    giris: { label: 'Giriş', color: 'success', icon: '↓' },
    cikis: { label: 'Çıkış', color: 'error', icon: '↑' },
    aktarim: { label: 'Aktarım', color: 'info', icon: '⇄' },
    duzeltme: { label: 'Düzeltme', color: 'warning', icon: '✎' },
};
